import React, { useState } from "react";
export default function TextForm(props) {

  // handling events
  const handleUpClick = () => {
    setText(text.toUpperCase());
    props.showAlert("Converted to Uppercase")
  };
  const handleLowClick = () => {
    setText(text.toLowerCase());
    props.showAlert("Converted to Lowercase")
  };
  const handleExtraSpaces = () => {
    let newText = text.split(/[ ]+/);
    setText(newText.join(" "))
    props.showAlert("Extra spaces removed")
  };
  const handleClearClick = () => {
    setText("");
    props.showAlert("Text cleared")
  };
  const handleCopyClick = () => {
    navigator.clipboard.writeText(text)
    document.getSelection().removeAllRanges()
    props.showAlert("Copied to clipboard")
  };
  const handleOnChange = (event) => {
    setText(event.target.value);
  };
  const [text, setText] = useState("");
  // text = "new text" -- wrong way to change the state
  // setText("new text");  //--correct way to change the state

  
  return (
    <>
      <div>
        <h2 className="formHeading my-3">{props.heading}</h2>
        <div className="my-3">
          <textarea
            className="form-control"
            id="myBox"
            rows="8"
            value={text}
            onChange={handleOnChange}
            style={{backgroundColor: props.mode==="dark"?"#13466e":"white",
                color: props.mode==="dark"?"white":"black"}}
          ></textarea>
        </div>
        <button disabled={text.length===0} className={`btn m-2`} style={{color:props.mode==="dark"?"white":"black",backgroundColor:props.mode==="dark"?"#042743":"white", borderWidth:"1px", borderStyle:"solid", borderColor:props.mode==="dark"?"white":"black"}} onClick={handleUpClick}>
          Convert to Uppercase
        </button>
        <button disabled={text.length===0} className={`btn m-2`} style={{color:props.mode==="dark"?"white":"black",backgroundColor:props.mode==="dark"?"#042743":"white", borderWidth:"1px", borderStyle:"solid", borderColor:props.mode==="dark"?"white":"black"}} onClick={handleLowClick}>
          Convert to Lowercase
        </button>
        <button disabled={text.length===0} className={`btn m-2`} style={{color:props.mode==="dark"?"white":"black",backgroundColor:props.mode==="dark"?"#042743":"white", borderWidth:"1px", borderStyle:"solid", borderColor:props.mode==="dark"?"white":"black"}} onClick={handleExtraSpaces}>
          Remove Extra Spaces
        </button>
        <button disabled={text.length===0} className={`btn m-2`} style={{color:props.mode==="dark"?"white":"black",backgroundColor:props.mode==="dark"?"#042743":"white", borderWidth:"1px", borderStyle:"solid", borderColor:props.mode==="dark"?"white":"black"}} onClick={handleClearClick}>
          Clear text
        </button>
        <button disabled={text.length===0} className={`btn m-2`} style={{color:props.mode==="dark"?"white":"black",backgroundColor:props.mode==="dark"?"#042743":"white", borderWidth:"1px", borderStyle:"solid", borderColor:props.mode==="dark"?"white":"black"}} onClick={handleCopyClick}>
          Copy to clipboard
        </button>
      </div>

      <div className="container my-3">
        <h1>Your text summary</h1>
        <p><b>{text.replace(/\s/).split(' ').filter(value => value !== "").length}</b> words, <b>{text.trim().length } characters</b> characters, <b>{text.replace(/\n/g, ".").split('.').filter(value => value !== "").length}</b> statements, <b>{text.split("?").length-1}</b> questions, <b>{text.split("!").length-1}</b> exclamations.</p>
        <p>{0.008 * text.split(" ").filter((element)=>{return element.length!==0}).length} Minute read </p>
        <h2>Preview</h2>
        <p>{text.length>0?text:"Enter something in the text box to preview it here"}</p>
      </div>
    </>
  );
}
